import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import ApiKeyController from '../controllers/ApiKeyController';
import commonHandler from '../errorHandlers/common-handler';
import { ApiKeyModel } from '../model/ApiKeyModel';
import { StoreState } from '../store-interfaces';
import CrudActionContainer from './CrudActionContainer';
import { integrationsHandler } from '../errorHandlers/integrations-handler';

class ApiKeysCRUDActions extends CrudActionContainer {
  constructor() {
    super('API_KEYS');
  }

  create(facebookPageId: number, apiKey: Partial<ApiKeyModel>) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));

      try {
        const response: ApiKeyModel = await ApiKeyController.postApiKey(
          facebookPageId,
          apiKey,
        );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(
          error,
          integrationsHandler(dispatch, this),
        );
      }
    };
  }

  retrieveById(facebookPageId: number, apiKeyId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAction));

      try {
        const response = await ApiKeyController.getById(
          facebookPageId,
          apiKeyId,
        );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        commonHandler(dispatch)(error);
      }
    };
  }

  retrieveAll(facebookPageId: number) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const response = await ApiKeyController.getAll(facebookPageId);
        dispatch(this.retrievedAll(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }

  update(facebookPageId: number, apiKey: ApiKeyModel) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.createAction));

      try {
        const response = await ApiKeyController.putApiKey(
          facebookPageId,
          apiKey,
        );
        dispatch(this.retrieved(response));

        return response;
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  }

  delete(facebookPageId: number, apiKey: ApiKeyModel) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.deleteAction));

      try {
        const response = await ApiKeyController.deleteApiKey(
          facebookPageId,
          apiKey.id,
        );
        dispatch(this.deleteLocal(apiKey));

        return response;
      } catch (error) {
        commonHandler(dispatch)(error);
      }
    };
  }
}

export const apiKeysCRUDActions = new ApiKeysCRUDActions();

export const useApiKeysCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  return {
    getKeys: (facebookPageId: number) =>
      dispatch(apiKeysCRUDActions.retrieveAll(facebookPageId)),
    createKey: (facebookPageId: number, apiKey: Partial<ApiKeyModel>) =>
      dispatch(apiKeysCRUDActions.create(facebookPageId, apiKey)),
    deleteKey: (facebookPageId: number, apiKey: ApiKeyModel) =>
      dispatch(apiKeysCRUDActions.delete(facebookPageId, apiKey)),
  };
};
